<template lang="html">
<div class="players-template">
  <table-data
    class="players"
    :items="players"
    @remove="removePlayer"
  >
    <player-cell
      slot="item"
      slot-scope="props"
      :cell-data="props.itemdata"
      :cell-index="props.itemindex"
    />
  </table-data>
  <form @submit.stop.prevent="onPlayerSubmit">
    <input
      class="new-player-name text-input"
      type="text"
      ref="inputPlayer"
      placeholder="Ajouter un joueur"
      v-model.lazy="name"
    />
  </form>
  <button
    class="button color-blue-500 start-button"
    @click="startGame()"
    :disabled="playersInGame.length < 2"
  >Nouvelle partie</button>
</div>
</template>

<script>
import playersStore from './../store/PlayersStore'
import gamesStore from './../store/GamesStore'
import TableData from '../view/table/TableData'
import PlayerCell from './PlayerCell'

export default {
  components: {
    TableData,
    PlayerCell,
  },
  data() {
    return {
      name: '',
      playerState: playersStore.state
    }
  },
  computed: {
    players() {
      return this.playerState.players
    },
    playersInGame() {
      return this.players.filter(player => player.enable)
    }
  },
  methods: {
    getPlayerGameCount(playerIndex) {
      const player = this.players[playerIndex]
      const games = gamesStore.state.games
      const isPlayer = p => player.name === p.name
      const isPlayerInGame = game => game.players.some(isPlayer)
      const playerGames = games.filter(isPlayerInGame)
      return playerGames.length
    },
    addPlayer() {
      playersStore.addPlayer(this.name)
      playersStore.pushLocalStorage()
      this.name = ''
    },
    removePlayer(playerIndex) {
      const playerGamesCount = this.getPlayerGameCount(playerIndex)
      const name = playersStore.state.players[playerIndex].name
      let isConfirmed = confirm(`Voulez vous vraiment supprimer le joueur ${name} ?`)
      if (!isConfirmed) return
      if (playerGamesCount) {
        const message = `Attention ce joueur est présent dans ${playerGamesCount} ${playerGamesCount > 1 ? 'parties' : 'partie'}.`
        isConfirmed = confirm(message)
        if (!isConfirmed) return
      }
      setTimeout(() => playersStore.removePlayer(playerIndex), 500)
    },
    startGame() {
      gamesStore.state.currentGame.setPlayers(this.playersInGame)
      this.$emit('onPushState', 'game')
    },
    onPlayerSubmit() {
      this.$refs.inputPlayer.blur()
    }
  },
  watch: {
    name(value) {
      if (value) this.addPlayer()
    }
  }
}
</script>

<style lang="stylus">
@import '../styles/common'

.players-template
  width 100%
  height 100%
  margin auto
  text-align center

  .players
    height calc(100% - 190px)

  .new-player-name
    font-size 1.4em
    width calc(100% - 2em)
    margin inherit 1em

  .new-player-icon
    font-size 1.4em

  .start-button
    font-size 1.4em
</style>


// WEBPACK FOOTER //
// PlayerList.vue?7c5a7878